import NavbarElement from '../components/sidebar/navbar';
import Sidebar from '../components/sidebar/sidebar';
import classNames from 'classnames';
import React, { useState } from 'react';
import VendorTable from '../components/vendors/vendor-table';
import FloatingButton from '../components/floating-button';
import AddNewVendorComponent from '../components/vendors/add-new-vendor';
import EditVendorComponent from '../components/vendors/edit-vendor';

function VendorsPage(props) {
  const [collapsed, setSidebarCollapsed] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  return (
    <div
      className={classNames({
        'grid bg-zinc-100 min-h-screen': true,
        'grid-cols-sidebar': !collapsed,
        'grid-cols-sidebar-collapsed': collapsed,
        'transition-[grid-template-columns] duration-300 ease-in-out': true,
      })}
    >
      <div
        style={{
          display: 'flex',
        }}
      >
        <div>
          <Sidebar
            collapsed={collapsed}
            setCollapsed={setSidebarCollapsed}
            shown={showSidebar}
          />
        </div>
        <div className="container 2xl:max-w-full" style={{ overflow: 'auto' }}>
          <div className="h-screen flex flex-col">
            <NavbarElement
              onMenuButtonClick={() => setShowSidebar((prev) => !prev)}
            />
            <div className="flex-grow overflow-hidden">
              <VendorTable
                setOpenEditModal={setOpenEditModal}
                openEditModal={openEditModal}
                setSelectedId={setSelectedId}
              />
            </div>
          </div>
          <FloatingButton
            onClick={() => setOpenModal(true)}
            text={'Add New Vendor'}
          />
          <AddNewVendorComponent
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
          <EditVendorComponent
            openEditModal={openEditModal}
            setOpenEditModal={setOpenEditModal}
            selectedId={selectedId}
          />
        </div>
      </div>
    </div>
  );
}

export default VendorsPage;
